"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isEditorialPublishDateProperty = exports.editorialPublishDatePropertyDefinition = void 0;
exports.editorialPublishDatePropertyDefinition = {
    view: {
        label: 'Editorial publish date',
        hint: 'Adding/Changing this date will not trigger a publish, but change the date referenced in the byline. This field should only be modified if a substantial amount of content has been changed.',
    },
    constraints: [],
    type: 'date-time',
    multiple: false,
    name: 'editorial-publish-date',
};
const isEditorialPublishDateProperty = (prop) => {
    return prop.name === exports.editorialPublishDatePropertyDefinition.name;
};
exports.isEditorialPublishDateProperty = isEditorialPublishDateProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZWRpdG9yaWFsLXB1Ymxpc2gtZGF0ZS5wcm9wZXJ0eS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9wcm9wZXJ0aWVzL2VkaXRvcmlhbC1wdWJsaXNoLWRhdGUucHJvcGVydHkudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBRWEsUUFBQSxzQ0FBc0MsR0FBRztJQUNwRCxJQUFJLEVBQUU7UUFDSixLQUFLLEVBQUUsd0JBQXdCO1FBQy9CLElBQUksRUFBRSw2TEFBNkw7S0FDcE07SUFDRCxXQUFXLEVBQUUsRUFBRTtJQUNmLElBQUksRUFBRSxXQUFXO0lBQ2pCLFFBQVEsRUFBRSxLQUFLO0lBQ2YsSUFBSSxFQUFFLHdCQUF3QjtDQUNDLENBQUE7QUFJMUIsTUFBTSw4QkFBOEIsR0FBRyxDQUFDLElBQWtCLEVBQXdDLEVBQUU7SUFDekcsT0FBTyxJQUFJLENBQUMsSUFBSSxLQUFLLDhDQUFzQyxDQUFDLElBQUksQ0FBQTtBQUNsRSxDQUFDLENBQUE7QUFGWSxRQUFBLDhCQUE4QixrQ0FFMUMifQ==